// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1xDQi","form":"styles_form__MwKCd"};